import { Component, EventEmitter, Input, Output, QueryList, ViewChildren, input, output } from "@angular/core";
import { UserSession } from "../../../models/user.model";
import { GridService } from "../../services/utils/grid.service";
import { FeatherIconsComponent } from "../feather-icons/feather-icons.component";
import { RoundedPaginationComponent } from "../rounded-pagination/rounded-pagination.component";

import { ActivatedRoute } from "@angular/router";
import { CommonModule } from "@angular/common";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";

import { AddCourseCompanyModalComponent } from "../../../superadmin/companies/add-course-company-modal/add-course-company-modal.component";
import { CompanyService } from "../../services/company/company.services";

@Component({
  selector: 'app-card-category',
  imports: [FeatherIconsComponent,RoundedPaginationComponent,CommonModule],
  templateUrl: './card-category.component.html',
  styleUrl: './card-category.component.scss'
})
export class CardCategoryComponent {

  @Input() obj: any;
  @Input() type: string;
  @Output() actionGoToEmit = new EventEmitter();
  @Output() actionSearchEmit = new EventEmitter();
  @Output() actionSectionEmit = new EventEmitter();

  private userSession: UserSession;
 
  public col_xl_12: boolean = false;
  public col_xl_2: boolean = false;
  public col_sm_3: boolean = false;
  public col_xl_3: boolean = true;
  public xl_4: boolean = true;
  public col_sm_4: boolean = false;
  public col_xl_4: boolean = false;
  public col_sm_6: boolean = true;
  public col_xl_6: boolean = false;
  public gridOptions: boolean = true;
  public active: boolean = false;

  public isShow: boolean = false;
  public searchValue:string="";
  public listView: boolean = false;
  _id: any
  companyData:any


  constructor(public gridService: GridService, private _activatedRoute: ActivatedRoute,private _modal: NgbModal, private _companyService: CompanyService) { 
    this._activatedRoute.queryParams.subscribe(params => {
      this._id = params['_id'];

    });
    if (this._id) {
      this.getCompanyById(this._id)
    }
      
  }

  ngOnInit() {
    if (!this.obj) {
      this.obj = {
        searchTerm: "",
        headers: [
          { name: "col1", detail: "col 1" },
          { name: "col2", detail: "col 2" },
          { name: "col3", detail: "col 3" },
          { name: "col4", detail: "col 4" },
          { name: "col5", detail: "col 5" },
          { name: "col6", detail: "col 6" , type:"date"},
          { name: "col1", detail: "button X", type:"button", action:()=>{alert("test");} },
          { name: "actions", detail: "Actions", options: "edit,goto,delete" }
        ],
        itemList: [
          { col1: "test", col2: "test", col3: "test2354", col4: "test", col5: "test", col6: "20/10/2021" },
          { col1: "test2", col2: "test3", col3: "test2345", col4: "test", col5: "test", col6: "20/10/2021" },
          { col1: "test3", col2: "test33", col3: "test2345", col4: "test", col5: "test", col6: "20/10/2021" },
          { col1: "test4", col2: "test4555", col3: "test445", col4: "test35", col5: "test345", col6: "20/10/2021" },
          { col1: "test4", col2: "test4555", col3: "test445", col4: "test35", col5: "test345", col6: "20/10/2021" },
        ],
      }
    }
    let userSessionRecover: string | null = sessionStorage.getItem("user");
    if (userSessionRecover == null) {
      return;
    }
    // this.userSession = JSON.parse(userSessionRecover);
    // if (this.userSession.role==USER_ROLE.COMPANY) {
    //   this.section = "/company/courses/category";
    // }else if (this.userSession.role==USER_ROLE.ADMIN) {
    //   this.section = "/admin/courses/category";
    // }
  }

  getCompanyById(_id: string): void {
    this._companyService.getCompanyById(_id).subscribe({
      next: (response) => {
        if (response.status) {
          this.companyData = response.data;
        } else {
          console.error('Error retrieving company details:', response.message);
        }
      },
      error: (error) => {
        console.error('API Error:', error);
      },
    });
  }

  gotoAddCourse() {
    let modalRef: NgbModalRef = this._modal.open(AddCourseCompanyModalComponent, { centered: true });
    modalRef.componentInstance.company = this.companyData;
    console.log("this.companyData.data", this.companyData);
    
    // modalRef.componentInstance.refrestTable = this.refrestTable;
  }

  actionSearch({value}:any) {
    this.actionSearchEmit.emit({value:value,page:0});
    this.searchValue=value;
  }

  actionGoSection(item:any) {
    this.actionSectionEmit.emit(item);
  }

  textLong(value:any){
    if(typeof value=="string"){
      if (value.length>60){
        return value.substring(0, 60)+"...";
      }else{
        return value;
      }
    }
    return value;
  }

  calculatePage(){
    if (this.obj.paginator.page<1) {
      this.obj.paginator.page++;
      return;
    }
    this.actionSearchEmit.emit({value:this.searchValue,page:this.obj.paginator.page});
  }
  includeInactive(e:any){
    this.obj.includeInactive=e.srcElement.checked;
    sessionStorage.setItem("courseStatusFilter",this.obj.includeInactive);
    this.actionSearch({value:this.searchValue})
  }
  gridOpens() {
    this.listView = false;
    this.gridService.gridOpen()
  }
  listOpens() {
    this.listView = true;
    this.gridService.listOpen()
  }
  grid2s() {
    this.listView = false;
    this.gridService.grid2()
  }
  grid3s() {
    this.listView = false;
    this.gridService.grid3()
  }
  grid6s() {
    this.listView = false;
    this.gridService.grid6()
  }

  ngDoCheck() {
    this.col_xl_12 = this.gridService.col_xl_12;
    this.col_xl_2 = this.gridService.col_xl_2;
    this.col_sm_3 = this.gridService.col_xl_12;
    this.col_xl_3 = this.gridService.col_xl_3;
    this.xl_4 = this.gridService.xl_4;
    this.col_sm_4 = this.gridService.col_sm_4;
    this.col_xl_4 = this.gridService.col_xl_4;
    this.col_sm_6 = this.gridService.col_sm_6;
    this.col_xl_6 = this.gridService.col_xl_6;
  }

  formatDescription(name:string){
    if(!this.col_xl_12)
    return name.substring(0, 20)+"...";
    else return name.substring(0, 100)+"...";;
  }
  

}
